import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

// Packages
import { Card, Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import PropTypes from 'prop-types';

// Components
import JobsTable from './JobsTable';
import ReversePagination from '../../utils/ReversePagination';
import JobsRemoveModal from './JobsRemoveModal';
import ConfirmDialog from '../../utils/ConfirmDialog';

// Actions
import { get_jobs_history, remove_jobs_history, retry_all_history } from '../../../actions/jobsActions';

const JobsHistory = (props) => {
	const { jobsType } = props;

	const { instance_id } = useParams();

	const dispatch = useDispatch();

	const { jobs_history_loading, jobs_history } = useSelector(state => state.jobs);

	const [modalShow, setModalShow] = useState(false);
	const [retryAllShow, setRetryAllShow] = useState(false);
	const [start, setStart] = useState(-10);
	const [end, setEnd] = useState(-1);
	const [limit] = useState(-10);
	const [reloadDate, setReloadDate] = useState(moment().format('L - LTS'));

	const nPages = Math.ceil(jobs_history.size / (limit * -1));

	useEffect(() => {
		dispatch(get_jobs_history(jobsType, instance_id, start, end));
	}, [start]);
	
	return (
		<Card className='shadow mb-5 bg-body rounded card-border'>
			<JobsRemoveModal
				show={modalShow}
				onHide={() => setModalShow(false)}
				title='Remove History Jobs'
				actionFunction={remove_jobs_history}
				count={jobs_history.size === undefined ? 0 : jobs_history.size}
			/>

			<ConfirmDialog
				show={retryAllShow}
				onHide={() => setRetryAllShow(false)}
				title='Retry All History Jobs'
				message={`Are you sure you want to retry all ${jobs_history.size || 0} history jobs?`}
				confirmFunction={() => {
					dispatch(retry_all_history(instance_id));
					setRetryAllShow(false);
				}}
			/>
			
			<Card.Body>
				<Card.Title className='text-center' as='h5'>History Jobs</Card.Title>
				<Row className='mb-3 align-items-center'>
					<Col className='text-start' xs='5'>
						<strong>History:</strong> {jobs_history.history}
					</Col>
					<Col className='text-center' xs='1'>
						<strong>Size:</strong> {jobs_history.size?.toLocaleString('es-MX')}
					</Col>
					<Col className='text-center' xs='4'>
						<strong>Last Jobs Refresh:</strong> {reloadDate}
					</Col>
					<Col className='text-end' xs='2'>
						<OverlayTrigger
							placement='bottom'
							overlay={<Tooltip id='button-tooltip-2'>Refresh</Tooltip>}
						>
							<Button type='button' className='jobs-actions me-3'
								onClick={() => { setReloadDate(moment().format('L - LTS')); dispatch(get_jobs_history(jobsType, instance_id, -10, -1)) }}
							>
								<i className='bi bi-arrow-clockwise bi-bold fs-5'></i>
							</Button>
						</OverlayTrigger>
						{jobsType === 'workers' &&
							<>
								<OverlayTrigger
									placement='bottom'
									overlay={<Tooltip>Retry All</Tooltip>}
								>
									<Button type='button' className='jobs-actions me-3'
										onClick={() => setRetryAllShow(true)}
										disabled={jobs_history?.elements?.length === 0}
									>
										<i className='bi bi-arrow-repeat fs-5'></i>
									</Button>
								</OverlayTrigger>
								<OverlayTrigger
									placement='bottom'
									overlay={<Tooltip id='button-tooltip-2'>Remove Jobs</Tooltip>}
								>
									<Button type='button' className='jobs-actions me-2' onClick={() => setModalShow(true)}
										disabled={jobs_history?.elements?.length === 0}
									>
										<i className='bi bi-trash-fill fs-5'></i>
									</Button>
								</OverlayTrigger>
							</>
						}
					</Col>
				</Row>

				<JobsTable 
					loading={jobs_history_loading}
					jobsType={jobsType}
					jobs={jobs_history.elements === undefined ? [] : jobs_history.elements}
					noJobsMsg='No history'
				/>
				<ReversePagination
					count={jobs_history.size === undefined ? 0 : jobs_history.size}
					arrayLength={jobs_history.elements === undefined ? 0 : jobs_history.elements.length}
					nPages={nPages}
					start={start}
					setStart={setStart}
					end={end}
					setEnd={setEnd}
					limit={limit}
				/>
			</Card.Body>
		</Card>
	);
}

JobsHistory.propTypes = {
	jobsType: PropTypes.string.isRequired
}

export default JobsHistory;
